export const LogoMark = ({ className = "h-9 w-auto" }) => (
  <img src="/img/logo-shield.webp" alt="" aria-hidden="true" className={`object-contain ${className}`} />
);

export const Logo = ({ testId = "brand-logo", className = "h-10 sm:h-11" }) => (
  <span data-testid={testId} className="flex items-center group">
    <img
      src="/img/logo-dark.webp"
      alt="Armat Defense"
      className={`w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03] ${className}`}
    />
  </span>
);
